import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";

/**
 * Clean half-circle gauge. Chart on top, number & unit below (no overlap).
 * Target is used only for pass/warn color logic (label removed).
 */
export default function Gauge({ value, max, label, unit, target, direction = "up_good", testId }) {
  const safeMax = Math.max(max || 100, value || 0);
  const filled = Math.max(0, Math.min(value || 0, safeMax));
  const remaining = safeMax - filled;

  let color = "#22c55e";
  if (target != null && value != null) {
    if (direction === "up_good") {
      if (value < target) color = "#ef4444";
      if (value >= target * 0.9 && value < target) color = "#f59e0b";
      if (value >= target) color = "#22c55e";
    } else {
      if (value > target) color = "#ef4444";
      if (value <= target * 1.1 && value > target) color = "#f59e0b";
      if (value <= target) color = "#22c55e";
    }
  }

  const data = [
    { name: "value", val: filled, color },
    { name: "rem", val: remaining, color: "#e2e8f0" },
  ];

  return (
    <div className="flex flex-col items-center min-w-0" data-testid={testId}>
      <div className="text-[10px] font-bold uppercase tracking-widest text-slate-500 text-center leading-snug min-h-[28px] flex items-center justify-center px-1 w-full">
        <span className="truncate max-w-full">{label}</span>
      </div>
      <div className="w-full max-w-[160px] h-[80px] mt-1">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={data}
              cx="50%"
              cy="100%"
              startAngle={180}
              endAngle={0}
              innerRadius="72%"
              outerRadius="100%"
              paddingAngle={0}
              dataKey="val"
              stroke="none"
              isAnimationActive={false}
            >
              {data.map((d) => <Cell key={`gauge-cell-${d.color}-${d.val}`} fill={d.color} />)}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
      </div>
      <div className="text-center mt-2">
        <div className="text-3xl font-black text-slate-900 leading-none tabular-nums">
          {value == null ? "—" : (typeof value === "number" ? value.toLocaleString(undefined, { maximumFractionDigits: 2 }) : value)}
        </div>
        {unit && <div className="text-[10px] font-medium text-slate-500 mt-1.5 uppercase tracking-wider">{unit}</div>}
      </div>
    </div>
  );
}
